export default __webpack_public_path__ + "static/media/header.41023399.png";